import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AuthStore } from '../../../core/auth/services/auth.store';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'secure-img',
  templateUrl: './secure-image.component.html',
  styleUrls: ['./secure-image.component.css'],
})
export class SecureImageComponent implements OnInit {
  @Input() src: string;
  @Input() fit = 'cover';
  @Input() background = false;
  @Output() onSecureRessourceLoad = new EventEmitter();
  safeSrc: string | SafeUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=';
  unSafeUrl: string;
  loaded = false;
  downloading = false;
  @Input() style: string;

  constructor(private renderer: Renderer2, private authStore: AuthStore, private domSanitizer: DomSanitizer) {}

  ngOnInit() {}

  public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
    this.renderer.addClass(target, visible ? 'active' : 'inactive');
    this.renderer.removeClass(target, visible ? 'inactive' : 'active');
    if (visible) {
      this.loadImage();
    }
  }

  loadImage() {
    if (this.loaded === true || this.downloading === true) {
      return;
    }
    try {
      this.downloading = true;
      fetch(this.src, {
        headers: {
          Authorization: 'Bearer ' + this.authStore.state.token.accessToken,
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            throw new Error();
          }
        })
        .then((blob) => {
          this.unSafeUrl = URL.createObjectURL(blob);
          this.safeSrc = this.domSanitizer.bypassSecurityTrustUrl(this.unSafeUrl);
          this.src = this.unSafeUrl;
          this.onSecureRessourceLoad.emit(this.safeSrc);
          this.loaded = true;
          this.downloading = false;
        })
        .catch((e) => {
          this.loaded = true;
          this.downloading = false;
        });
    } catch {
      this.loaded = true;
      this.downloading = false;
    }
  }
}
